module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./EventZoneView.js"));
	}, "QuickBuyEventZoneView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=QuickBuyEventZoneView!./src/pages/Shop/Member/TradeManage/QuickBuy/EventZone/EventZoneView.js
// module id = 1969
// module chunks = 367